// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__Z22wd","logoHiddenMenu":"Logo_logoHiddenMenu__GVttT"};